export { default as connectEntitlement } from './connect-entitlement';
export { default } from './entitlements-wrapper-container';

export const greaterThan = (i) => (v) => Number(v) && Number(v) > i;
export const greaterThanOrEqualTo = (i) => (v) => Number(v) && Number(v) >= i;
